export const HUB = {
  pageType: 'Hub',
};

export const VENUE = {
  pageType: 'Venue',
};

export const SEARCH_RESULTS = {
  pageType: 'SearchResults',
};

export const LANDING = {
  pageType: 'Landing',
};

export const LOCATION_DETAILS = {
  pageType: 'LocationDetails',
};

export const CHECKOUT = {
  pageType: 'Checkout',
};

export const RECEIPT = {
  pageType: 'Receipt',
};

export const MY_PASSES = {
  pageType: 'MyPasses',
};

export const PASS = {
  pageType: 'Pass',
};

export const OUR_APPS = {
  pageType: 'OurApps',
};

export const HELP = {
  pageType: 'Help',
};

export const HOW_IT_WORKS = {
  pageType: 'HowItWorks',
};

export const SIGN_IN_SIGN_UP = {
  pageType: 'SignInSignUp',
};

export const ACCOUNT = {
  pageType: 'Account',
};

export const SEARCH = {
  pageType: 'Search',
};

export const BOOKINGS = {
  pageType: 'Bookings',
};

export const OVERLAY = {
  pageType: 'Overlay',
};

export const ERROR = {
  pageType: 'Error',
};

export const SCAN = {
  pageType: 'Scan',
};

export const FRICTION_FREE_FLOW = {
  pageType: 'FrictionFreeFlow',
};

export const LIST = {
  pageType: 'List',
};

export const DETAILS = {
  pageType: 'Details',
};

export const PORTAL_LOGIN = {
  pageType: 'PortalLogin',
};

export const PORTAL_HOME = {
  pageType: 'PortalHome',
};

export const PORTAL_NAVIGATION = {
  pageType: 'PortalNavigation',
};

export const PORTAL_SETTINGS = {
  pageType: 'PortalSettings',
};

export const PORTAL_REPORTS = {
  pageType: 'PortalReports',
};

export const PORTAL_OPERATIONS = {
  pageType: 'PortalOperations',
};

export const PORTAL_PRICING = {
  pageType: 'PortalPricing',
};

export const PORTAL_VALIDATIONS = {
  pageType: 'PortalValidations',
};

export const PORTAL_COUPONS = {
  pageType: 'PortalCoupons',
};

export const PORTAL_MONTHLY = {
  pageType: 'PortalMonthly',
};

export const PORTAL_PRESALE = {
  pageType: 'PortalPresale',
};

export const PORTAL_TICKETS = {
  pageType: 'PortalTickets',
};

export const PORTAL_INSIGHTS = {
  pageType: 'PortalInsights',
};

export const PORTAL_ALERTS = {
  pageType: 'PortalAlerts',
};

export const PORTAL_ACTIVITY = {
  pageType: 'PortalActivity',
};
